import React from 'react';

const GalleryPage = React.lazy(() => import('pages/Gallery/GalleryPage'));
const GalleryAddPage = React.lazy(() => import('pages/Gallery/GalleryAddPage'));

const galleryRoute = [
  {
    path: '/gallery',
    exact: true,
    name: 'Danh sách hình ảnh',
    function: 'CMS_GALLERY_VIEW',
    component: GalleryPage,
  },
  {
    path: '/gallery/add',
    exact: true,
    name: 'Thêm mới hình ảnh',
    function: 'CMS_GALLERY_ADD',
    component: GalleryAddPage,
  },
  {
    path: '/gallery/edit/:image_id',
    exact: true,
    name: 'Chỉnh sửa hình ảnh',
    function: 'CMS_GALLERY_EDIT',
    component: GalleryAddPage,
  },
  {
    path: '/gallery/detail/:image_id',
    exact: true,
    name: 'Chi tiết hình ảnh',
    function: 'CMS_GALLERY_VIEW',
    component: GalleryAddPage,
  },
];

export default galleryRoute;
